import React, {useEffect, useRef} from "react";
import {styled} from "@mui/material/styles";

const Input = styled("input")({
    display: "none",
});

const FileInput = ({files, selectFiles, ACCEPTED_FILE_TYPES}) => {
    const inputRef = useRef(null);

    useEffect(() => {
        if (files.length === 0) {
            inputRef.current.value = "";
        }
    }, [files]);

    return (
        <Input
            type="file"
            id="upload-data"
            name="upload-data"
            onChange={selectFiles}
            accept={ACCEPTED_FILE_TYPES.join(", ")} // Разрешенные типы файлов
            multiple // Разрешаем выбор нескольких файлов
            ref={inputRef} // Ссылка на элемент input
        />
    );
};

export {FileInput};
